import { Component, HostBinding, Input } from '@angular/core';
import { environment } from 'environments/environment';
import { LocalStorage } from '../../local-storage.class';
import { Contact } from '../shared/contact';

@Component({
    selector: 'app-contact-photo',
    templateUrl: './contact-photo.component.html',
    styleUrls: ['./contact-photo.component.scss'],
    standalone: false,
})
export class ContactPhotoComponent {
    @Input() contact: Contact;

    /**
     * Locally chosen photo, shown before the upload has finished
     */
    @Input() previewUrl: string;

    /**
     * Shows the pencil on hover, to make clear the photo can be replaced
     */
    @HostBinding('class.editable')
    @Input()
    editable = false;

    getImageUrl(): string | null {
        if (!this.contact?.image_file) {
            return null;
        }

        return `${environment.apiEndpoint}file/contacts/${this.contact.image_file}?access_token=${LocalStorage.getUserToken()}`;
    }
}
